import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { Record } from 'src/app/models/record';
import { ApiService } from '../api.service';

@Injectable({
  providedIn: 'root',
})
export class ResourceResolver  {
  constructor(private apiService: ApiService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<Record> {
    const params = route.paramMap.get('slug');

    const paramsArray = params.split('-');
    const id = paramsArray[paramsArray.length - 1];

    return this.apiService.getRecord(id, false, true);
  }
}
